import { hydrateRoot, createRoot } from 'react-dom/client'
import type { OnRenderClientAsync } from 'vike/types'
import { PageShell } from './PageShell'
import './types'

export const onRenderClient: OnRenderClientAsync = async (pageContext) => {
  const { Page, pageProps = {}, isHydration } = pageContext

  const container = document.getElementById('page-view')!

  const page = (
    <PageShell pageContext={pageContext}>
      <Page {...pageProps} />
    </PageShell>
  )

  if (isHydration) {
    hydrateRoot(container, page)
  } else {
    // For subsequent navigations (SPA mode)
    const root = createRoot(container)
    root.render(page)
  }
}
